import httpApiApplication from '@/app/http/httpApiApplication';

import { type Jurisdiction } from '../models/Organization';

export const organizationService = {
  getJurisdictions: async (): Promise<Array<Jurisdiction>> => {
    return httpApiApplication.get<Array<Jurisdiction>>('/jurisdictions');
  }
};
